import {MarkdownViewer} from '@github-ui/markdown-viewer'
import {sanitize} from '@github-ui/sanitize'
import {useMemo} from 'react'

import styles from './ArtifactPanelContent.module.css'
import type {IssueArtifactType} from './types'

export type PanelArtifact = {
  id: string
  type: IssueArtifactType
  name: string
  body: string
  bodyHTML: string
}

type ArtifactPanelBodyProps = {
  artifact: PanelArtifact
}

/** Just the rendered markdown (or plain-text fallback) for an artifact. */
export function ArtifactPanelBody({artifact}: ArtifactPanelBodyProps) {
  const sanitizedHTML = useMemo(() => (artifact.bodyHTML ? sanitize(artifact.bodyHTML) : ''), [artifact.bodyHTML])

  return (
    // Scrollable region needs tabIndex so keyboard users can scroll body content
    // when it contains no focusable children (e.g. plain-text fallback). WCAG SCR34.
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    <div className={styles.Body} role="region" aria-label={artifact.name} tabIndex={0}>
      {sanitizedHTML ? (
        <MarkdownViewer verifiedHTML={sanitizedHTML} />
      ) : (
        <pre className={styles.PlainBody}>{artifact.body}</pre>
      )}
    </div>
  )
}
